@if (isSapModal) {
<div class="sapNotification">
  <div class="sap-message">
    <span class="sap-message__label--gray"
          [attr.data-test]="'label-messageColor'">
    </span>
    <div class="sap-message--content">
      <div>
        <span aria-hidden="true"
              class="sap-message--content__icon icon-warning icon-warning__circle"
              [attr.data-test]="'sapMessage-icon'">
        </span>
      </div>
      <span class="sap-message--content__text" [attr.data-test]="'sapMessage-text'">
        {{ 'sap-p40-disabled-modal-text1' | translate }}
        <b>{{ 'sap-p40-disabled-modal-text2' | translate }}</b>
        {{ 'sap-p40-disabled-modal-text3' | translate }}
        <b>{{ 'sap-p40-disabled-modal-text4' | translate }}</b>
        {{ 'sap-p40-disabled-modal-text5' | translate }}
        <a href="mailto:{{ 'config.sap_p40_email' | translate }}">{{ 'config.sap_p40_email' | translate }}</a>.
        {{ 'sap-p40-disabled-modal-enabled-date' | translate }}
      </span>
      <span>
        <button
            type="button"
            class="sap-message--content__close"
            aria-label="Close notification"
            (click)="hideNotification()">
          <i aria-hidden="true" class="icon-close sap-message--content__close"></i>
        </button>
      </span>
    </div>
  </div>
</div>
}
